<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 14.25H11.5M7 16.5H13C13.8284 16.5 14.5 15.8284 14.5 15V5C14.5 4.17157 13.8284 3.5 13 3.5H7C6.17157 3.5 5.5 4.17157 5.5 5V15C5.5 15.8284 6.17157 16.5 7 16.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M11.875 9.0625L10 10.9375L8.125 9.0625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 10V6.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'MobileSavingIcon'
}
</script>

